import type { MeterKind } from '@tunasong/music-lib'

/**
 * Rhythm Trainer URL-param parsers. The welcome screen owns gating:
 *   - `?mode=meter` (default) / `?mode=subdivision` — pre-selects card.
 *   - `?meter=<kind>` (optional) — focused-meter mode (only honored when
 *     `mode=meter`). Generates the same meter each question.
 * Unknown / missing values return `null` so the welcome screen falls back to
 * its default behavior (no pre-selection).
 *
 * Spec: docs/superpowers/specs/2026-05-22-rhythm-trainer-v1-design.md §7
 */
export type RhythmSubMode = 'meter' | 'subdivision' | 'grouping'

export const parseRhythmSubMode = (raw: string | null): RhythmSubMode | null => {
  if (raw === 'meter' || raw === 'subdivision' || raw === 'grouping') {
    return raw
  }
  return null
}

export const parseMeterParam = (raw: string | null): MeterKind | null => {
  if (
    raw === '4-4' ||
    raw === '3-4' ||
    raw === '6-8' ||
    raw === '5-4' ||
    raw === '7-8'
  ) {
    return raw
  }
  return null
}
